import fetchClient, { ApiResponse } from '../api-client'
import { UploadUserPkgReceiptPayload } from './types/UploadUserPkgReceiptPayload'
import { UserPkg } from './types/UserPkg'

export const getUserPkgs = async () => {
  const res = await fetchClient.get<ApiResponse<UserPkg[]>>('/user-pkg')
  return res.data.data
}

export const getOldUserPkgs = async () => {
  const res = await fetchClient.get<ApiResponse<{ response: UserPkg[] }>>('/packages')
  return res.data.data?.response
}

export const uploadUserPkgReceipt = async ({ file, packageId, price }: UploadUserPkgReceiptPayload): Promise<UserPkg> => {
  try {
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    const formData = new FormData()
    if (file) {
      if (!allowedFileTypes.includes(file.type)) {
        throw new Error(`file type not allowed: ${file.type}`)
      }
      formData.append('file', file)
    }
    if (price) {
      formData.append('price', price.toString())
    }

    formData.append('packageId', packageId)

    const res = await fetchClient.post(`/user-pkg/uploadReceipt`, formData)
    // console.log("uploadFile - res:", res)

    return res.data.data
  } catch (error) {
    console.log('uploadFile - error:', error)
    throw error
  }
}
